import timg1 from '../images/team/team_member_image_1.webp'
import timg2 from '../images/team/team_member_image_2.webp'
import timg3 from '../images/team/team_member_image_3.webp'
import timg4 from '../images/team/team_member_image_4.webp'
import timg5 from '../images/team/team_member_image_5.webp'

import aldi from '../images/clients/aldi_jas.png'
import siti from '../images/clients/siti.png'
import sukirman from '../images/clients/sukirman.jpeg'
import laja from '../images/clients/laja.png'
import pria from '../images/clients/orang.png'
import Bram from '../images/clients/Bram.png'

const Teams = [
   {
      Id: '4',
      tImg: siti,
      name: 'Siti Zulfah',
      slug: 'Daxton-Atlas',
      title: 'President Commisioner',
      linkedin: 'https://www.linkedin.com/in/siti-zulfah-5904b226b/',
   },
   {
      Id: '2',
      tImg: sukirman,
      name: 'Sukirman',
      slug: 'Orion-Jasper',
      title: 'Commisioner',
      linkedin: 'https://www.linkedin.com/in/sukirman-5904b226b/',
   },
   {
      Id: '3',
      tImg: laja,
      name: 'Laja Lapian',
      slug: 'Maverick-Phoenix',
      title: 'Commisioner',
      linkedin: 'https://www.linkedin.com/in/laja-lapian-5a2b6639/',
   },
   {
      Id: '1',
      tImg: Bram,
      name: 'Bram King Abdul Aziz Surbakti',
      slug: 'Atticus-Sterling',
      title: 'President Director',
      linkedin: 'https://www.linkedin.com/in/bram-5a2b6639/',
   },
   {
      Id: '5',
      tImg: aldi,
      name: 'Muhammad April Rinaldi',
      slug: 'August-Everest',
      title: 'Head Technician Operation',
      linkedin: 'https://www.linkedin.com/in/aldi-5a2b6639/',
   },
]

export default Teams;
